<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-sys__slinvitetender}">
      <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
        <el-form-item>
          <el-input v-model="dataForm.id" placeholder="id" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="getDataList()">{{ $t('query') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="info" @click="exportHandle()">{{ $t('export') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('sys:slinvitetender:save')" type="primary" @click="addOrUpdateHandle()">{{ $t('add') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('sys:slinvitetender:delete')" type="danger" @click="deleteHandle()">{{ $t('deleteBatch') }}</el-button>
        </el-form-item>
      </el-form>
      <el-table v-loading="dataListLoading" :data="dataList" border @selection-change="dataListSelectionChangeHandle" style="width: 100%;">
        <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>
        <el-table-column prop="id" label="主键" header-align="center" align="center"></el-table-column>
        <el-table-column prop="userId" label="邀请用户id" header-align="center" align="center"></el-table-column>
        <el-table-column prop="sendStatus" label="0未发送1已发送2发送失败3发送中" header-align="center" align="center"></el-table-column>
        <el-table-column prop="countDate" label="投资时间（201607）" header-align="center" align="center"></el-table-column>
        <el-table-column prop="addTime" label="添加时间" header-align="center" align="center"></el-table-column>
        <el-table-column prop="modifyTime" label="修改时间" header-align="center" align="center"></el-table-column>
        <el-table-column prop="activeModifyTime" label="活动期间最后投资时间" header-align="center" align="center"></el-table-column>
        <el-table-column prop="totalMoney" label="投资总金额" header-align="center" align="center"></el-table-column>
        <el-table-column prop="activeTotalMoney" label="活动期间投资总金额" header-align="center" align="center"></el-table-column>
        <el-table-column prop="totalInterest" label="总收益" header-align="center" align="center"></el-table-column>
        <el-table-column prop="activeTotalInterest" label="活动期间总收益" header-align="center" align="center"></el-table-column>
        <el-table-column prop="inviteMoney" label="被邀请人投资总额" header-align="center" align="center"></el-table-column>
        <el-table-column prop="activeInviteMoney" label="活动期间被邀请人投资总额" header-align="center" align="center"></el-table-column>
        <el-table-column prop="inviteInterest" label="被邀请人投资利息" header-align="center" align="center"></el-table-column>
        <el-table-column prop="activeInviteInterest" label="活期期间被邀请人投资利息" header-align="center" align="center"></el-table-column>
        <el-table-column prop="reconStatus" label="对账状态" header-align="center" align="center"></el-table-column>
        <el-table-column prop="bizFlow" label="交易订单号" header-align="center" align="center"></el-table-column>
        <el-table-column prop="returnCash" label="预计已返现金额" header-align="center" align="center"></el-table-column>
        <el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="150">
          <template slot-scope="scope">
            <el-button v-if="$hasPermission('sys:slinvitetender:update')" type="text" size="small" @click="addOrUpdateHandle(scope.row.id)">{{ $t('update') }}</el-button>
            <el-button v-if="$hasPermission('sys:slinvitetender:delete')" type="text" size="small" @click="deleteHandle(scope.row.id)">{{ $t('delete') }}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle">
      </el-pagination>
      <!-- 弹窗, 新增 / 修改 -->
      <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
    </div>
  </el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import AddOrUpdate from './slinvitetender-add-or-update'
export default {
  mixins: [mixinViewModule],
  data () {
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/sys/slinvitetender/page',
        getDataListIsPage: true,
        exportURL: '/sys/slinvitetender/export',
        deleteURL: '/sys/slinvitetender',
        deleteIsBatch: true
      },
      dataForm: {
        id: ''
      }
    }
  },
  components: {
    AddOrUpdate
  }
}
</script>
